import { Injectable } from '@angular/core';
import { MusicControls } from '@ionic-native/music-controls';
import { Events } from 'ionic-angular';

import { BaseService } from './base-service';

@Injectable()
export class ControlsService extends BaseService {

  constructor(
    public events: Events,
    public musicControls: MusicControls
   ) {
    super();
    console.log('Hello ControlsService Provider');
  }

  // call on track creation (playback start)
  // TODO: this should be called from the play action
  // TODO: this should be destroyed on the stop / end action
  create(track) {
    this.destroy();
    console.log('CREATE', track);
    this.musicControls.create({
      track       : track.title, // optional, default : ''
      artist      : track.artist, // optional, default : ''
      cover       : track.art, // optional, default : nothing
      isPlaying   : true, // optional, default : true
      dismissable : false, // optional, default : false

      // hide previous/next/close buttons:
      hasPrev   : false, // show previous button, optional, default: true
      hasNext   : false, // show next button, optional, default: true
      hasClose  : true, // show close button, optional, default: false

      // iOS only, optional
      album       : '', // optional, default: ''
      duration : 60, // optional, default: 0
      elapsed : 10, // optional, default: 0

      // Android only, optional
      // text displayed in the status bar when the notification (and the ticker) are updated
      ticker    : `Now playing "${track.title}"`
    });

    // register callback
    this.musicControls.subscribe().subscribe(action => {
      this.eventHandler(action);
    });

    // start listening for events
    this.musicControls.listen();
  }

  destroy() {
    this.musicControls.destroy();
  }

  setIsPlaying(isPlaying) {
    this.musicControls.updateIsPlaying(isPlaying);
  }

  setElapsed(time) {
    this.musicControls.updateElapsed({
      elapsed: time, // seconds
      isPlaying: true
    });
  }

  eventHandler(action) {
    // TODO: call stuff from audio-service
    const message = JSON.parse(action).message;
    switch(message) {
      case 'music-controls-next':
        break;
      case 'music-controls-previous':
        break;

      case 'music-controls-pause':
        this.events.publish('track:playpause');
        break;
      case 'music-controls-play':
        this.events.publish('track:playpause');
        break;

      case 'music-controls-destroy':
        this.destroy();
        break;

      // External controls (iOS only)
      case 'music-controls-toggle-play-pause' :
        this.events.publish('track:playpause');
        break;

      case 'music-controls-seek-to':
        const seekToInSeconds = JSON.parse(action).position;
        this.musicControls.updateElapsed({
          elapsed: seekToInSeconds,
          isPlaying: true
        });
        break;

      // Headset events (Android only)
      case 'music-controls-media-button' :
        break;
      case 'music-controls-headset-unplugged':
        break;
      case 'music-controls-headset-plugged':
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/controls-service.ts